import React from 'react';
import './HouseDesign.css';
import useScrollToTop from '../components/useScrollToTop';
import image2 from '../img/houseplan.avif';
import ReusableLanding from '../components/ReusableLanding';
import FAQ from '../components/FAQ';
import Button from '../components/Button';
import DesignProcess from '../components/DesignProcess';
import HouseplanfaqData from '../components/Houseplanfaqdata';
import floorplan1 from '../img/floor_plan1.avif';
import floorplan2 from '../img/img_floorplan_6.avif'; 
import floorplan3 from '../img/img_floorplan_4.avif';
import floorplan4 from '../img/img_floorplan_2.avif'; // Replace with actual images
import floorplan5 from '../img/img_floorplan_3.avif'; // Replace with actual images
import floorplan6 from '../img/floor_plan_5.avif'; // Replace with actual images
import floorplan7 from '../img/floor_plan_6.avif'; 
import floorplan8 from '../img/floor_plan_7.avif'; 
import { FaRulerCombined, FaVectorSquare, FaHome, FaPencilRuler,FaFileAlt,FaLightbulb } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';
const FloorPlan = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Floor Plan"
                description="A well-designed floor plan is the foundation of a functional and comfortable home. Explore our range of floor plan services to optimize your living space."
            />
            <div className="house-design-page">
                <section className="floor-plan-services-section">
                    <h2>Our Comprehensive Floor Plan Services</h2>
                    <p>We offer a range of detailed and innovative floor plan services to meet diverse needs, from initial concepts to detailed construction documents.</p>
                    <div className="floor-plan-services-grid">
                        <div className="floor-plan-service-item">
                            <FaRulerCombined className="service-icon" />
                            <h3>Detailed 2D Floor Plans</h3>
                            <p>Our precise 2D floor plans provide accurate room dimensions, wall layouts, door and window placements, and furniture arrangements. These plans are essential for understanding spatial relationships and functionality.</p>
                            <ul>
                                <li>Precise measurements and scaling</li>
                                <li>Clear labeling of rooms and features</li>
                                <li>Furniture layout options</li>
                                <li>Suitable for initial planning and permits</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaVectorSquare className="service-icon" />
                            <h3>Immersive 3D Floor Plans</h3>
                            <p>Visualize your future home with our stunning 3D floor plans. These plans offer a realistic perspective of the interior space, helping you understand volume, flow, and potential design aesthetics.</p>
                            <ul>
                                <li>Realistic textures and finishes</li>
                                <li>Multiple viewing angles</li>
                                <li>Enhanced understanding of spatial volume</li>
                                <li>Ideal for presentations and visualization</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaHome className="service-icon" />
                            <h3>Renovation and Remodeling Floor Plans</h3>
                            <p>Planning a renovation? Our specialized floor plans for existing spaces help you visualize and optimize your remodeling project, ensuring seamless integration of new designs with the current structure.</p>
                            <ul>
                                <li>Accurate representation of existing structures</li>
                                <li>Integration of new layouts and features</li>
                                <li>Identification of structural considerations</li>
                                <li>Facilitates communication with contractors</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaPencilRuler className="service-icon" />
                            <h3>Custom Floor Plan Design</h3>
                            <p>Tailored to your unique lifestyle and requirements, our custom floor plan design service involves in-depth consultation and iterative design to create a home that perfectly fits your needs and preferences.</p>
                            <ul>
                                <li>Personalized design consultations</li>
                                <li>Iterative design process with feedback</li>
                                <li>Optimization for your specific needs</li>
                                <li>Creation of unique and functional layouts</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaFileAlt className="service-icon" /> {/* You might need to import this */}
                            <h3>Construction Document Sets</h3>
                            <p>Beyond basic floor plans, we provide comprehensive construction document sets, including detailed plans, elevations, sections, and specifications necessary for obtaining building permits and guiding the construction process.</p>
                            <ul>
                                <li>Detailed architectural drawings</li>
                                <li>Structural and MEP (Mechanical, Electrical, Plumbing) layouts (optional add-on)</li>
                                <li>Material specifications</li>
                                <li>Essential for accurate construction and costing</li>
                            </ul>
                        </div>
                        <div className="floor-plan-service-item">
                            <FaLightbulb className="service-icon" /> {/* You might need to import this */}
                            <h3>Space Planning and Optimization</h3>
                            <p>Maximize the functionality and flow of your home with our expert space planning services. We analyze your needs and create layouts that optimize every square foot for comfortable and efficient living.</p>
                            <ul>
                                <li>Analysis of traffic flow and adjacencies</li>
                                <li>Furniture placement strategies</li>
                                <li>Consideration of natural light and ventilation</li>
                                <li>Enhancing overall livability</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <div className="benefits-section">
  <h2>Unlock the Potential of Your Home with Professional Floor Plans</h2>
  <p className="benefits-intro">Investing in a professionally designed floor plan goes beyond just lines on paper. It's about creating a home that truly works for you, enhancing your daily life and maximizing your investment.</p>
  <div className="floor-plan-services-grid">
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-arrows-alt"></i></div>
      <h3>Optimized Space Utilization</h3>
      <p>Say goodbye to wasted corners and awkward layouts. Our expert planning ensures every square foot is thoughtfully utilized, creating more functional and spacious living areas.</p>
    </div>
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-route"></i></div>
      <h3>Seamless Flow and Functionality</h3>
      <p>Experience a home that lives well. We design intuitive layouts that promote a natural flow between rooms, making everyday tasks easier and enhancing the overall livability of your space.</p>
    </div>
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-eye"></i></div>
      <h3>Crystal-Clear Visualization Before Building</h3>
      <p>Eliminate guesswork and confidently envision your future home. Our detailed plans, especially 3D renderings, provide a clear understanding of the layout, preventing costly surprises during construction.</p>
    </div>
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-chart-line"></i></div>
      <h3>Enhanced Property Value</h3>
      <p>A well-designed floor plan is a significant asset. It not only improves your living experience but also increases the appeal and long-term value of your property.</p>
    </div>
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-lightbulb"></i></div>
      <h3>Tailored to Your Unique Lifestyle</h3>
      <p>Your home should reflect you. We take the time to understand your specific needs, preferences, and lifestyle, creating a floor plan that truly caters to the way you live.</p>
    </div>
    <div className="floor-plan-service-item" style={{ backgroundColor: '#e9f0ff', border: '1px solid #b8daff' }}>
      <div className="service-icon"><i className="fas fa-comments"></i></div>
      <h3>Improved Communication with Builders</h3>
      <p>Clear and detailed floor plans serve as a precise blueprint for your construction team, minimizing misunderstandings and ensuring accurate execution of your vision.</p>
    </div>
  </div>
</div>
                
                <section style={{ padding: '0px 20px' }}>
                    <h2>Visualize Your Space</h2>
                    <p>See how a floor plan comes to life with our dynamic visualization.</p>
                    <iframe width="100%" height="640" title="our spaces" frameborder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://kuula.co/share/collection/71lz8?logo=1&info=1&fs=1&vr=0&thumbs=1&inst=0"></iframe>
                </section>
                
                <section className="floor-plan-examples ">
                    <h2>Explore Sample Floor Plans</h2>
                    <p>
                        Get inspired by some examples of our diverse floor plan designs. Click on the images to view them in more detail.
                    </p>
                    <div className="floor-plan-grid">
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan1} alt="3BHK Floor Plan" loading="lazy"/>
                            <h3>3BHK Floorplan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan2} alt="Multi BHK Apartment Floor Plan" loading="lazy"/>
                            <h3>Multi BHK Apartment FloorPlan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan3} alt="6bhk  Floor Plan" loading="lazy"/>
                            <h3>6bhk Floor Plan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan4} alt="Multi BHK Apartment FloorPlan" loading="lazy"/>
                            <h3>Multi BHK Apartment FloorPlan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan5} alt="3bhk Floor Plan" loading="lazy"/>
                            <h3>3bhk Houseplan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan6} alt="3BHK Floor Plan" loading="lazy"/>
                            <h3>3BHK Floorplan</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan7} alt="3BHK House Plan with Drawing Room for Modern Living in Patna" loading="lazy"/>
                            <h3>3BHK House Plan with Drawing Room for Modern Living in Patna</h3>
                        </div>
                        <div className="floor-plan-item">
                            <img className="house-plan-img" src={floorplan8} alt="4BHK Floor Plan" loading="lazy"/>
                            <h3>4BHK Floor Plan</h3>
                        </div>
                    </div>
                </section>

                <section style={{padding:'8px'}} >
                    <h2>Ready to Bring Your Vision to Life?</h2>
                    <p>
                        Our expert team is ready to help you create the perfect floor plan for your dream home. Contact us today to discuss your project and get started.
                    </p>
                    <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Contact Us</Button>
                </a>
                </section>
                <section className="page-section" style={{padding:'8px'}}>
        <h2 className="section-title">Residential Options</h2>
        <ul className="list-items">
            <li><Link to="/floor-plans/2bhk-house-plans" className="list-link">Explore 2BHK House Plans</Link></li>
            <li><Link to="/floor-plans/3bhk-house-plans" className="list-link">Discover 3BHK Hosue Plans</Link></li>
            <li><Link to="/floor-plans/4bhk-house-plans" className="list-link">Discover 4BHK House Plans</Link></li>
            <li><Link to="/floor-plans/3d-home-plans" className="list-link">Discover 3d-home-plans Plans</Link></li>
            <li><Link to="/floor-plans/village-homes" className="list-link">Discover village-homes Plans</Link></li>
            <li><Link to="/floor-plans/simple-homes" className="list-link">Discover simple-homes Plans</Link></li>
            <li><Link to="/floor-plans/vastu-homes" className="list-link">Discover vastu-homes  Plans</Link></li>
            <li><Link to="/floor-plans/mappass" className="list-link">How to pass your houseplan/naksha</Link></li>
        </ul>
      </section>

      <section className="page-section" style={{padding:'8px'}}>
        <h2 className="section-title">Commercial and Other Options</h2>
        <ul className="list-items">
            <li><Link to="/floor-plans/shop-commercial-plans-bihar" className="list-link">View Shop and Commercial Space Plans</Link></li>
            <li><Link to="/floor-plans/office-space-plans-bihar" className="list-link">Explore Office Space Plans</Link></li>
            <li><Link to="/floor-plans/other-building-types-bihar" className="list-link">See Other Building Types</Link></li>
        </ul>
      </section>

                <DesignProcess />
                <FAQ faqData={HouseplanfaqData} />

            </div>
        </>
    );
};

export default FloorPlan;